import { Injectable } from '@angular/core';
import { BaseApiService } from "../common/base-api.service";
import { HttpClient } from "@angular/common/http";
import { SettingsProviderService } from "../common/settings-provider.service";
import { AuditInfo } from '../domain-model/audit-info.class';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'Audit');
  }

  getAuditHistory(companyId: string): Observable<AuditInfo[]>{
    return this.post<AuditInfo[]>('GetAuditHistory', { CompanyId: companyId });
  }
}
